/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamAggregateCohortStateResponse } from './oralExamAggregateCohortStateResponse';

export type GenericApiResponseOralExamAggregateCohortStateResponseData = OralExamAggregateCohortStateResponse | null;
